const View = () => import('./View')
const Form = () => import('./Form')

export default function install(Vue) {
  Vue.component('review-view', View)
  Vue.component('review-form', Form)
}
